import {Injectable} from '@angular/core';
import {map, Observable, of, take} from 'rxjs';
import {environment} from '@environments/environment';
import {HttpClient, HttpStatusCode} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {HostDTO, HostSendMessageRequest} from '@domain/host/host.dto';
import {ValidateEmailRequest} from '@core/auth/auth.interfaces';

@Injectable({
  providedIn: 'root'
})
export class PublicHostApi {

  protected readonly apiPrefix = 'public/host';
  private readonly API_VALIDATE_EMAIL = '/validate-email';

  constructor(
    private readonly http: HttpClient
  ) { }

  // public getHost(hostId?: string | null): Observable<HostResponse | null> {
  //   if (!hostId) {
  //     return of(null);
  //   }
  //   return this.http.get<HostResponse>(`${environment.apiUrl}/${this.apiPrefix}/${hostId}`);
  // }

  public sendMessage(hostId: string, messageRequest: HostSendMessageRequest): Observable<boolean> {
    return this.http.post<void>(`${environment.apiUrl}/${this.apiPrefix}/${hostId}/message`, messageRequest).pipe(
      map(() => true)
    );
  }

  public validateEmail(host: HostDTO, validateRequest: ValidateEmailRequest): Observable<boolean> {
    return this.http
      .post<void>(
        `${environment.apiUrl}/${this.apiPrefix}/${host.id}${this.API_VALIDATE_EMAIL}`,
        validateRequest,
        {observe: 'response'}
      )
      .pipe(
        map(response => response?.status === HttpStatusCode.NoContent),
        catchError(_err => of(false)),
        take(1)
      );
  }
}
